import { fg } from '@atlaskit/platform-feature-flags/fg';
import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';

import { KnowledgeCardsIntentType } from './knowledge-cards-intent-type';

type Props = {
	currentUserId: string;
	viewAllUrl?: string;
	cloudId: string;
} & (
	| { type: KnowledgeCardsIntentType.PERSON }
	| { type: KnowledgeCardsIntentType.TEAM; teamId: string | undefined }
);

export const useTeamsAppLinks: (props: Props) => {
	viewAllLink: string;
	viewAllOnNavigate: (e?: React.MouseEvent | React.KeyboardEvent) => void;
	worksWithHref: string;
	worksWithOnNavigate: (e?: React.MouseEvent | React.KeyboardEvent) => void;
	profileHref: string;
	profileOnNavigate: (e?: React.MouseEvent | React.KeyboardEvent) => void;
	toUser: (userId: string) => import('@atlaskit/teams-app-config/types').NavigationResult;
} = (props: Props) => {
	const { cloudId, currentUserId, viewAllUrl } = props;
	const backupViewAllUrl = `https://hello.atlassian.net/people/${currentUserId}/work`;

	const { href: profileWorkList, onNavigate: profileWorkListOnNavigate } = navigateToTeamsApp(
		props.type === KnowledgeCardsIntentType.PERSON
			? {
					type: 'USER_WORK',
					payload: {
						userId: currentUserId || '',
					},
					cloudId,
				}
			: {
					type: 'TEAM',
					payload: {
						teamId: props.teamId || '',
					},
					cloudId,
				},
	);

	const { href: worksWithHref, onNavigate: worksWithOnNavigate } = navigateToTeamsApp(
		props.type === KnowledgeCardsIntentType.PERSON
			? {
					type: 'USER',
					payload: {
						userId: currentUserId || '',
						section: 'workswith',
					},
					cloudId,
				}
			: {
					type: 'TEAM',
					payload: {
						teamId: props.teamId || '',
					},
					cloudId,
				},
	);

	const { href: profileHref, onNavigate: profileOnNavigate } = navigateToTeamsApp(
		props.type === KnowledgeCardsIntentType.PERSON
			? {
					type: 'USER',
					payload: {
						userId: currentUserId || '',
					},
					cloudId,
				}
			: {
					type: 'TEAM',
					payload: {
						teamId: props.teamId || '',
					},
					cloudId,
				},
	);

	const toUser = (userId: string) =>
		navigateToTeamsApp({
			type: 'USER',
			payload: {
				userId,
			},
			cloudId,
		});

	const viewAllLink = fg('platform-adopt-teams-nav-config')
		? profileWorkList
		: viewAllUrl || backupViewAllUrl;

	return {
		viewAllLink,
		viewAllOnNavigate: profileWorkListOnNavigate,
		worksWithHref,
		worksWithOnNavigate,
		profileHref,
		profileOnNavigate,
		toUser,
	};
};
